import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';

import BaseResponse from '../../models/src/model/BaseResponse';
import {
  EventsControllerDtoEventStarterPackHistoryListRequest, EventsControllerDtoEventStarterPackInfoAddBudgetRequest,
  EventsControllerDtoEventStarterPackInfoCreateRequest, EventsControllerDtoEventStarterPackInfoDepositRequest,
  EventsControllerDtoEventStarterPackInfoDetailRequest,
  EventsControllerDtoEventStarterPackInfoListRequest,
  EventsControllerDtoEventStarterPackInfoRemoveRequest,
  EventsControllerDtoEventStarterPackInfoUpdateRequest,
  PerplayEventsApi,
} from '../../models/src';
import {
  setStarterPackEventHistoryPagination,
  setStarterPackEventListPagination,
  setTotalCount,
  starterPackEventInfoDetails,
  starterPackEventList,
  starterPackEventResponse,
} from '../../actions/event/starterPackEventActions';
import {
  STARTER_PACK_EVENT_ADD_BUDGET,
  STARTER_PACK_EVENT_CREATE_REQUEST,
  STARTER_PACK_EVENT_DEPOSIT_REQUEST,
  STARTER_PACK_EVENT_INFO_DELETE_REQUEST,
  STARTER_PACK_EVENT_INFO_DETAILS_REQUEST,
  STARTER_PACK_EVENT_INFO_UPDATE_REQUEST,
  STARTER_PACK_EVENT_LIST_REQUEST,
} from '../../constants/event/starterPackEventConstatns';
import changeNumApi from '../../../api/ui/changeNumApi';
import EventsControllerDtoEventStarterPackInfoListResponse
  from '../../models/src/model/EventsControllerDtoEventStarterPackInfoListResponse';
import EventsControllerDtoEventStarterPackInfoDetailResponse
  from '../../models/src/model/EventsControllerDtoEventStarterPackInfoDetailResponse';
import EventsControllerDtoEventStarterPackHistoryListResponse
  from '../../models/src/model/EventsControllerDtoEventStarterPackHistoryListResponse';

const api = new PerplayEventsApi(config.API_CLIENT);

function* starterPackEventListRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventStarterPackInfoListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    const result = yield api.apiPerplayEventsEventStarterPackInfoListPost(
      { eventsControllerDtoEventStarterPackInfoListRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventStarterPackInfoListResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(starterPackEventList(data.list));
      yield put(setTotalCount(data.totalCount));
      yield put(
        setStarterPackEventListPagination(payload.page, data.totalCount),
      );
    } else {
      yield put(
        starterPackEventResponse(data.resultCode, '조회 실패 로그확인 필요.'),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* starterPackEventCreateRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventStarterPackInfoCreateRequest();
    requestData.regDuration = payload.regDuration;
    requestData.needUsedPower = payload.needUsedPower;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    requestData.rewardXper = parseFloat(changeNumApi.mul18(payload.rewardXper));
    requestData.rewardItem1 = payload.rewardItem1;
    requestData.rewardItem1Count = payload.rewardItem1Count;
    requestData.rewardItem2 = payload.rewardItem2;
    requestData.rewardItem2Count = payload.rewardItem2Count;
    requestData.rewardItem3 = payload.rewardItem3;
    requestData.rewardItem3Count = payload.rewardItem3Count;
    requestData.initialXper = parseFloat(
      changeNumApi.mul18(payload.initialXper),
    );
    const result = yield api.apiPerplayEventsEventStarterPackInfoCreatePost(
      { eventsControllerDtoEventStarterPackInfoCreateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(starterPackEventResponse(data.resultCode, '이벤트 등록 성공.'));
    } else {
      yield put(
        starterPackEventResponse(
          data.resultCode,
          `${data.description}으로 등록 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* starterPackEventInfoDetailsRequestSaga(payload) {
  try {
    yield put(starterPackEventInfoDetails(null, null));
    yield put(starterPackEventResponse(null, null));

    const requestDetailsData = new EventsControllerDtoEventStarterPackInfoDetailRequest();
    requestDetailsData.packNo = payload.packNo;

    const detailsResult =
      yield api.apiPerplayEventsEventStarterPackInfoDetailPost(
        { eventsControllerDtoEventStarterPackInfoDetailRequest: requestDetailsData },
        () => {},
      );
    const detailsData = api.apiClient.deserialize(
      detailsResult,
      EventsControllerDtoEventStarterPackInfoDetailResponse,
    );
    console.log('detailsData: ', detailsData);

    const requestHistoryData = new EventsControllerDtoEventStarterPackHistoryListRequest();
    requestHistoryData.packNo = payload.packNo;
    requestHistoryData.page = payload.page;
    requestHistoryData.pageLength = payload.pageLength;
    requestHistoryData.searchType = payload.searchType;
    requestHistoryData.searchString = payload.searchString;

    const historyResult =
      yield api.apiPerplayEventsEventStarterPackHistoryListPost(
        { eventsControllerDtoEventStarterPackHistoryListRequest: requestHistoryData },
        () => {},
      );
    const historyData = api.apiClient.deserialize(
      historyResult,
      EventsControllerDtoEventStarterPackHistoryListResponse,
    );
    console.log('historyData: ', historyData);

    if (detailsData.resultCode === 200 && historyData.resultCode === 200) {
      // Update scheduleInfo and logInfo with data values
      yield put(
        starterPackEventInfoDetails(
          {
            packNo: detailsData.packNo,
            regDuration: detailsData.regDuration,
            needUsedPower: detailsData.needUsedPower,
            beginAt: detailsData.beginAt,
            endAt: detailsData.endAt,
            rewardXper: detailsData.rewardXper,
            rewardItem1: detailsData.rewardItem1,
            rewardItem1Count: detailsData.rewardItem1Count,
            rewardItem2: detailsData.rewardItem2,
            rewardItem2Count: detailsData.rewardItem2Count,
            rewardItem3: detailsData.rewardItem3,
            rewardItem3Count: detailsData.rewardItem3Count,
            initialXper: detailsData.initialXper,
            balanceXper: changeNumApi.div18(detailsData.balanceXper),
            depositTransactionStatus: detailsData.depositTransactionStatus,
            xperUsed: changeNumApi.div18(detailsData.xperUsed),
            walletAddress: detailsData.walletAddress,
            depositAmount: detailsData.depositAmount,
          },
          historyData.list,
        ),
      );
    }

    yield put(setTotalCount(historyData.totalCount));
    yield put(
      setStarterPackEventHistoryPagination(
        payload.page,
        historyData.totalCount,
        payload.searchType,
        payload.searchString,
      ),
    );

    if (detailsData.resultCode === 200 && historyData.resultCode === 200) {
    } else if (detailsData.resultCode !== 200) {
      yield put(
        starterPackEventResponse(
          detailsData.resultCode,
          `${detailsData.description}으로 이벤트 일정 조회 실패 로그확인 필요.`,
        ),
      );
    } else if (historyData.resultCode !== 200) {
      yield put(
        starterPackEventResponse(
          historyData.resultCode,
          `${detailsData.description}으로 참여내역 조회 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* starterPackEventUpdateRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventStarterPackInfoUpdateRequest();
    requestData.packNo = payload.packNo;
    requestData.regDuration = payload.regDuration;
    requestData.needUsedPower = payload.needUsedPower;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    requestData.rewardXper = payload.rewardXper;
    requestData.rewardItem1 = payload.rewardItem1;
    requestData.rewardItem1Count = payload.rewardItem1Count;
    requestData.rewardItem2 = payload.rewardItem2;
    requestData.rewardItem2Count = payload.rewardItem2Count;
    requestData.rewardItem3 = payload.rewardItem3;
    requestData.rewardItem3Count = payload.rewardItem3Count;
    requestData.initialXper = payload.initialXper;
    const result = yield api.apiPerplayEventsEventStarterPackInfoUpdatePost(
      { eventsControllerDtoEventStarterPackInfoUpdateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(starterPackEventResponse(data.resultCode, '이벤트 변경 성공.'));
    } else {
      yield put(
        starterPackEventResponse(
          data.resultCode,
          `${data.description}으로 변경 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* starterPackEventDeleteRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventStarterPackInfoRemoveRequest();
    requestData.packNo = payload.packNo;
    const result = yield api.apiPerplayEventsEventStarterPackInfoRemovePost(
      { eventsControllerDtoEventStarterPackInfoRemoveRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(starterPackEventResponse(data.resultCode, '이벤트 삭제 성공.'));
    } else {
      yield put(
        starterPackEventResponse(
          data.resultCode,
          `${data.description}으로 삭제 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* starterPackEventDepositRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventStarterPackInfoDepositRequest();
    requestData.packNo = payload.packNo;
    requestData.transactionHash = payload.transactionHash;
    const result = yield api.apiPerplayEventsEventStarterPackInfoDepositPost(
      { eventsControllerDtoEventStarterPackInfoDepositRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(
        starterPackEventResponse(data.resultCode, 'transactionHash 전송 성공'),
      );
    } else {
      yield put(
        starterPackEventResponse(
          data.resultCode,
          `${data.description}으로 결과 전송 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* starterPackEventAddBudgetRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventStarterPackInfoAddBudgetRequest();
    requestData.packNo = payload.packNo;
    requestData.addXper = payload.addXper;
    requestData.transactionHash = payload.transactionHash;
    console.log('requestData: ', requestData);
    const result = yield api.apiPerplayEventsEventStarterPackInfoAddBudgetPost(
      { eventsControllerDtoEventStarterPackInfoAddBudgetRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(
        starterPackEventResponse(
          data.resultCode,
          '예산 추가 transactionHash 전송 성공',
        ),
      );
    } else {
      yield put(
        starterPackEventResponse(
          data.resultCode,
          `${data.description}으로 결과 전송 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* starterPackEventRootSaga() {
  yield all([
    takeEvery(STARTER_PACK_EVENT_LIST_REQUEST, starterPackEventListRequestSaga),
    takeEvery(STARTER_PACK_EVENT_CREATE_REQUEST, starterPackEventCreateRequestSaga),
    takeEvery(STARTER_PACK_EVENT_INFO_DETAILS_REQUEST, starterPackEventInfoDetailsRequestSaga),
    takeEvery(STARTER_PACK_EVENT_INFO_UPDATE_REQUEST, starterPackEventUpdateRequestSaga),
    takeEvery(STARTER_PACK_EVENT_INFO_DELETE_REQUEST, starterPackEventDeleteRequestSaga),
    takeEvery(STARTER_PACK_EVENT_DEPOSIT_REQUEST, starterPackEventDepositRequestSaga),
    takeEvery(STARTER_PACK_EVENT_ADD_BUDGET, starterPackEventAddBudgetRequestSaga),
  ]);
}

const starterPackEventSagas = [fork(starterPackEventRootSaga)];

export default starterPackEventSagas;
